import { Controller, useFormContext } from "react-hook-form"
import InputTabs from "src/shared/components/forms/input-tabs/InputTabs"
import InputMoney from "src/shared/components/forms/InputMoney/InputMoney"
import InputTextSuggestions, {
    InputTextSuggestion,
} from "src/shared/components/forms/input-text-suggestions/InputTextSuggestions"
import DollarCircle from "src/shared/icons/DollarCircle"
import accountBoxFill from "src/shared/icons/accountBoxFill"
import { times } from "src/shared/helpers/calculator"
import FormSection from "../../components/FormSection/FormSection"
import FormSectionRow from "../../components/FormSectionRow/FormSectionRow"
import { DefaultValuesType } from "../../VentaHabitacion.types"

interface PropinaProps {
    // Hay propinas capturadas, el colaborador que la recibió se vuelve requerido
    hasPropinas: boolean
    colaboradoresSuggestions: InputTextSuggestion[]
}

// Propina opcional de un pago único, por porcentaje o monto
const Propina = ({ hasPropinas, colaboradoresSuggestions }: PropinaProps) => {
    const { control, watch } = useFormContext<DefaultValuesType>()
    const porcentajePropina = watch("porcentajePropina")
    const costoGeneral = watch("costs.general")

    return (
        <FormSection title="Propina (opcional)" toggable>
            <FormSectionRow style={{ alignItems: "center" }}>
                <Controller
                    name="porcentajePropina"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <InputTabs
                            className={"registro-incidencia__tabs-place"}
                            label={"Monto o porcentaje"}
                            items={[
                                {
                                    bigLabel: "10%",
                                    label: `$${times(costoGeneral, 0.1)}`,
                                    value: "0.1",
                                },
                                {
                                    bigLabel: "15%",
                                    label: `$${times(costoGeneral, 0.15)}`,
                                    value: "0.15",
                                },
                                {
                                    label: "Otro monto",
                                    icon: "dollarCircle",
                                    value: "Otro",
                                },
                            ]}
                            withCheckOnSelected
                            value={value + ""}
                            onChange={onChange}
                        />
                    )}
                />
                {porcentajePropina === "Otro" && (
                    <Controller
                        control={control}
                        name="montoPropina"
                        rules={{ required: true, validate: (v) => (v || 0) > 0 }}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <InputMoney
                                value={value}
                                onChange={onChange}
                                inputWrapperClass="venta-habitacion-input"
                                placeholder="Monto de propina"
                                label="Monto de propina"
                                icon={DollarCircle}
                                error={!!error}
                                errorhinttext={error?.type === "validate" ? "Ingresa una propina mayor a 0" : ""}
                            />
                        )}
                    />
                )}
            </FormSectionRow>
            <FormSectionRow>
                <Controller
                    control={control}
                    name="colaboradorRecibioPropina"
                    rules={{
                        required: hasPropinas,
                        validate: (v) => !hasPropinas || (!!v?.id && !!v?.title),
                    }}
                    render={({ field: { value, onChange }, fieldState: { error } }) => (
                        <InputTextSuggestions
                            suggestionsListWidth="255px"
                            className="venta-habitacion-input"
                            suggestions={colaboradoresSuggestions}
                            value={value || ""}
                            inputTextConfig={{
                                label: "¿Quién recibió la propina?",
                                placeholder: "Nombre del personal",
                                type: "text",
                                icon: accountBoxFill,
                                error: !!error,
                                errorhinttext:
                                    error?.type === "validate" || error?.type === "required"
                                        ? "Escribe el nombre del responsable"
                                        : "",
                            }}
                            onChange={onChange}
                        />
                    )}
                />
            </FormSectionRow>
        </FormSection>
    )
}

export default Propina
